import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { IdGenerator } from "../../rxjs/configureEpics"
import type { AccessData, PermissionData, UserAccount } from "../../data/types"
import { PermissionType } from "./selectors"

export const composePermission = (accessId: string, name: string, idgen: IdGenerator): PermissionData => {
    return {
        accessId: accessId,
        name: PermissionType[name],
        id: idgen.next(),
    }
}

export const isUserAuthorizedForAction = (
    userAccount: Maybe<UserAccount>,
    accessLevels: AccessData[],
    permisionName: string
): boolean => {
    if (!userAccount || !userAccount.isActive) {
        return false
    }

    const accessLevelId = userAccount.accessId
    const access = accessLevels.find(a => a.id === accessLevelId)
    return access != null && !!access.permissions.find(p => p.name === permisionName)
}
